import { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AuthorLayout from 'components/AuthorLayout';
import { RootState } from 'store/store';
import {
  fetchLatestMessages,
  inboxSelector,
  InboxState,
} from 'store/features/inbox/inboxSlice';

import dayjs from 'dayjs';

function Inbox(): ReactElement<HTMLElement> {
  const dispatch = useDispatch();
  const inbox = useSelector<RootState, InboxState>(inboxSelector);

  useEffect(() => {
    if (inbox.status === 'idle') {
      dispatch(fetchLatestMessages());
    }
  }, [inbox.status, dispatch]);

  return (
    <AuthorLayout title="Inbox">
      <table className="w-full table-auto">
        <thead>
          <tr>
            <th className="py-2 border-b-4 border-gray-100 text-left text-sm font-normal font-display">
              #
            </th>
            <th className="py-2 border-b-4 border-gray-100 text-left text-sm font-normal font-display">
              From
            </th>
            <th className="py-2 border-b-4 border-gray-100 text-left text-sm font-normal font-display">
              Email
            </th>
            <th className="py-2 border-b-4 border-gray-100 text-left text-sm font-normal font-display">
              Received At
            </th>
          </tr>
        </thead>
        <tbody>
          {inbox.entities.length === 0 ? (
            <tr>
              <td colSpan={4}>
                <p className="py-10 text-center text-sm text-gray-500 font-body">
                  No message.
                </p>
              </td>
            </tr>
          ) : (
            inbox.entities.map((message, idx) => (
              <tr className="cursor-pointer hover:bg-red-100" key={message.id}>
                <td className="py-1.5">
                  <span className="py-1 px-2.5 w-6 h-6 rounded-full block bg-red-100 text-xs text-center text-primary font-body">
                    {idx + 1}
                  </span>
                </td>
                <td className="py-1.5 text-gray-700 text-sm font-body">
                  {message.name}
                </td>
                <td className="py-1.5 text-gray-700 text-sm font-body">
                  {message.email}
                </td>
                <td className="py-1.5 text-gray-700 text-sm font-body">
                  {dayjs(message.created_at).format('MMM, DD YYYY')}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </AuthorLayout>
  );
}

export default Inbox;
